/**
 * Country ISO codes and dial codes for phone input.
 * ISO codes match Flag.tsx (e.g. US, GB, CA). Dial codes include leading '+'.
 */
export type PhoneCountryCode = { iso: string; dialCode: string };

export const PHONE_COUNTRY_CODES: PhoneCountryCode[] = [
  {
    iso: 'AF',
    dialCode: '+93',
  },
  {
    iso: 'AX',
    dialCode: '+358',
  },
  {
    iso: 'AL',
    dialCode: '+355',
  },
  {
    iso: 'DZ',
    dialCode: '+213',
  },
  {
    iso: 'AS',
    dialCode: '+1684',
  },
  {
    iso: 'AD',
    dialCode: '+376',
  },
  {
    iso: 'AO',
    dialCode: '+244',
  },
  {
    iso: 'AI',
    dialCode: '+1264',
  },
  {
    iso: 'AQ',
    dialCode: '+672',
  },
  {
    iso: 'AG',
    dialCode: '+1268',
  },
  {
    iso: 'AR',
    dialCode: '+54',
  },
  {
    iso: 'AM',
    dialCode: '+374',
  },
  {
    iso: 'AW',
    dialCode: '+297',
  },
  {
    iso: 'AU',
    dialCode: '+61',
  },
  {
    iso: 'AT',
    dialCode: '+43',
  },
  {
    iso: 'AZ',
    dialCode: '+994',
  },
  {
    iso: 'BS',
    dialCode: '+1242',
  },
  {
    iso: 'BH',
    dialCode: '+973',
  },
  {
    iso: 'BD',
    dialCode: '+880',
  },
  {
    iso: 'BB',
    dialCode: '+1246',
  },
  {
    iso: 'BY',
    dialCode: '+375',
  },
  {
    iso: 'BE',
    dialCode: '+32',
  },
  {
    iso: 'BZ',
    dialCode: '+501',
  },
  {
    iso: 'BJ',
    dialCode: '+229',
  },
  {
    iso: 'BM',
    dialCode: '+1441',
  },
  {
    iso: 'BT',
    dialCode: '+975',
  },
  {
    iso: 'BO',
    dialCode: '+591',
  },
  {
    iso: 'BA',
    dialCode: '+387',
  },
  {
    iso: 'BW',
    dialCode: '+267',
  },
  {
    iso: 'BR',
    dialCode: '+55',
  },
  {
    iso: 'IO',
    dialCode: '+246',
  },
  {
    iso: 'BN',
    dialCode: '+673',
  },
  {
    iso: 'BG',
    dialCode: '+359',
  },
  {
    iso: 'BF',
    dialCode: '+226',
  },
  {
    iso: 'BI',
    dialCode: '+257',
  },
  {
    iso: 'KH',
    dialCode: '+855',
  },
  {
    iso: 'CM',
    dialCode: '+237',
  },
  {
    iso: 'CA',
    dialCode: '+1',
  },
  {
    iso: 'CV',
    dialCode: '+238',
  },
  {
    iso: 'KY',
    dialCode: '+ 345',
  },
  {
    iso: 'CF',
    dialCode: '+236',
  },
  {
    iso: 'TD',
    dialCode: '+235',
  },
  {
    iso: 'CL',
    dialCode: '+56',
  },
  {
    iso: 'CN',
    dialCode: '+86',
  },
  {
    iso: 'CX',
    dialCode: '+61',
  },
  {
    iso: 'CC',
    dialCode: '+61',
  },
  {
    iso: 'CO',
    dialCode: '+57',
  },
  {
    iso: 'KM',
    dialCode: '+269',
  },
  {
    iso: 'CG',
    dialCode: '+242',
  },
  {
    iso: 'CD',
    dialCode: '+243',
  },
  {
    iso: 'CK',
    dialCode: '+682',
  },
  {
    iso: 'CR',
    dialCode: '+506',
  },
  {
    iso: 'CI',
    dialCode: '+225',
  },
  {
    iso: 'HR',
    dialCode: '+385',
  },
  {
    iso: 'CU',
    dialCode: '+53',
  },
  {
    iso: 'CY',
    dialCode: '+357',
  },
  {
    iso: 'CZ',
    dialCode: '+420',
  },
  {
    iso: 'DK',
    dialCode: '+45',
  },
  {
    iso: 'DJ',
    dialCode: '+253',
  },
  {
    iso: 'DM',
    dialCode: '+1767',
  },
  {
    iso: 'DO',
    dialCode: '+1849',
  },
  {
    iso: 'EC',
    dialCode: '+593',
  },
  {
    iso: 'EG',
    dialCode: '+20',
  },
  {
    iso: 'SV',
    dialCode: '+503',
  },
  {
    iso: 'GQ',
    dialCode: '+240',
  },
  {
    iso: 'ER',
    dialCode: '+291',
  },
  {
    iso: 'EE',
    dialCode: '+372',
  },
  {
    iso: 'ET',
    dialCode: '+251',
  },
  {
    iso: 'FK',
    dialCode: '+500',
  },
  {
    iso: 'FO',
    dialCode: '+298',
  },
  {
    iso: 'FJ',
    dialCode: '+679',
  },
  {
    iso: 'FI',
    dialCode: '+358',
  },
  {
    iso: 'FR',
    dialCode: '+33',
  },
  {
    iso: 'GF',
    dialCode: '+594',
  },
  {
    iso: 'PF',
    dialCode: '+689',
  },
  {
    iso: 'GA',
    dialCode: '+241',
  },
  {
    iso: 'GM',
    dialCode: '+220',
  },
  {
    iso: 'GE',
    dialCode: '+995',
  },
  {
    iso: 'DE',
    dialCode: '+49',
  },
  {
    iso: 'GH',
    dialCode: '+233',
  },
  {
    iso: 'GI',
    dialCode: '+350',
  },
  {
    iso: 'GR',
    dialCode: '+30',
  },
  {
    iso: 'GL',
    dialCode: '+299',
  },
  {
    iso: 'GD',
    dialCode: '+1473',
  },
  {
    iso: 'GP',
    dialCode: '+590',
  },
  {
    iso: 'GU',
    dialCode: '+1671',
  },
  {
    iso: 'GT',
    dialCode: '+502',
  },
  {
    iso: 'GG',
    dialCode: '+44',
  },
  {
    iso: 'GN',
    dialCode: '+224',
  },
  {
    iso: 'GW',
    dialCode: '+245',
  },
  {
    iso: 'GY',
    dialCode: '+595',
  },
  {
    iso: 'HT',
    dialCode: '+509',
  },
  {
    iso: 'VA',
    dialCode: '+379',
  },
  {
    iso: 'HN',
    dialCode: '+504',
  },
  {
    iso: 'HK',
    dialCode: '+852',
  },
  {
    iso: 'HU',
    dialCode: '+36',
  },
  {
    iso: 'IS',
    dialCode: '+354',
  },
  {
    iso: 'IN',
    dialCode: '+91',
  },
  {
    iso: 'ID',
    dialCode: '+62',
  },
  {
    iso: 'IR',
    dialCode: '+98',
  },
  {
    iso: 'IQ',
    dialCode: '+964',
  },
  {
    iso: 'IE',
    dialCode: '+353',
  },
  {
    iso: 'IM',
    dialCode: '+44',
  },
  {
    iso: 'IL',
    dialCode: '+972',
  },
  {
    iso: 'IT',
    dialCode: '+39',
  },
  {
    iso: 'JM',
    dialCode: '+1876',
  },
  {
    iso: 'JP',
    dialCode: '+81',
  },
  {
    iso: 'JE',
    dialCode: '+44',
  },
  {
    iso: 'JO',
    dialCode: '+962',
  },
  {
    iso: 'KZ',
    dialCode: '+77',
  },
  {
    iso: 'KE',
    dialCode: '+254',
  },
  {
    iso: 'KI',
    dialCode: '+686',
  },
  {
    iso: 'KP',
    dialCode: '+850',
  },
  {
    iso: 'KR',
    dialCode: '+82',
  },
  {
    iso: 'KW',
    dialCode: '+965',
  },
  {
    iso: 'KG',
    dialCode: '+996',
  },
  {
    iso: 'LA',
    dialCode: '+856',
  },
  {
    iso: 'LV',
    dialCode: '+371',
  },
  {
    iso: 'LB',
    dialCode: '+961',
  },
  {
    iso: 'LS',
    dialCode: '+266',
  },
  {
    iso: 'LR',
    dialCode: '+231',
  },
  {
    iso: 'LY',
    dialCode: '+218',
  },
  {
    iso: 'LI',
    dialCode: '+423',
  },
  {
    iso: 'LT',
    dialCode: '+370',
  },
  {
    iso: 'LU',
    dialCode: '+352',
  },
  {
    iso: 'MO',
    dialCode: '+853',
  },
  {
    iso: 'MK',
    dialCode: '+389',
  },
  {
    iso: 'MG',
    dialCode: '+261',
  },
  {
    iso: 'MW',
    dialCode: '+265',
  },
  {
    iso: 'MY',
    dialCode: '+60',
  },
  {
    iso: 'MV',
    dialCode: '+960',
  },
  {
    iso: 'ML',
    dialCode: '+223',
  },
  {
    iso: 'MT',
    dialCode: '+356',
  },
  {
    iso: 'MH',
    dialCode: '+692',
  },
  {
    iso: 'MQ',
    dialCode: '+596',
  },
  {
    iso: 'MR',
    dialCode: '+222',
  },
  {
    iso: 'MU',
    dialCode: '+230',
  },
  {
    iso: 'YT',
    dialCode: '+262',
  },
  {
    iso: 'MX',
    dialCode: '+52',
  },
  {
    iso: 'FM',
    dialCode: '+691',
  },
  {
    iso: 'MD',
    dialCode: '+373',
  },
  {
    iso: 'MC',
    dialCode: '+377',
  },
  {
    iso: 'MN',
    dialCode: '+976',
  },
  {
    iso: 'ME',
    dialCode: '+382',
  },
  {
    iso: 'MS',
    dialCode: '+1664',
  },
  {
    iso: 'MA',
    dialCode: '+212',
  },
  {
    iso: 'MZ',
    dialCode: '+258',
  },
  {
    iso: 'MM',
    dialCode: '+95',
  },
  {
    iso: 'NA',
    dialCode: '+264',
  },
  {
    iso: 'NR',
    dialCode: '+674',
  },
  {
    iso: 'NP',
    dialCode: '+977',
  },
  {
    iso: 'NL',
    dialCode: '+31',
  },
  {
    iso: 'AN',
    dialCode: '+599',
  },
  {
    iso: 'NC',
    dialCode: '+687',
  },
  {
    iso: 'NZ',
    dialCode: '+64',
  },
  {
    iso: 'NI',
    dialCode: '+505',
  },
  {
    iso: 'NE',
    dialCode: '+227',
  },
  {
    iso: 'NG',
    dialCode: '+234',
  },
  {
    iso: 'NU',
    dialCode: '+683',
  },
  {
    iso: 'NF',
    dialCode: '+672',
  },
  {
    iso: 'MP',
    dialCode: '+1670',
  },
  {
    iso: 'NO',
    dialCode: '+47',
  },
  {
    iso: 'OM',
    dialCode: '+968',
  },
  {
    iso: 'PK',
    dialCode: '+92',
  },
  {
    iso: 'PW',
    dialCode: '+680',
  },
  {
    iso: 'PS',
    dialCode: '+970',
  },
  {
    iso: 'PA',
    dialCode: '+507',
  },
  {
    iso: 'PG',
    dialCode: '+675',
  },
  {
    iso: 'PY',
    dialCode: '+595',
  },
  {
    iso: 'PE',
    dialCode: '+51',
  },
  {
    iso: 'PH',
    dialCode: '+63',
  },
  {
    iso: 'PN',
    dialCode: '+872',
  },
  {
    iso: 'PL',
    dialCode: '+48',
  },
  {
    iso: 'PT',
    dialCode: '+351',
  },
  {
    iso: 'PR',
    dialCode: '+1939',
  },
  {
    iso: 'QA',
    dialCode: '+974',
  },
  {
    iso: 'RO',
    dialCode: '+40',
  },
  {
    iso: 'RU',
    dialCode: '+7',
  },
  {
    iso: 'RW',
    dialCode: '+250',
  },
  {
    iso: 'RE',
    dialCode: '+262',
  },
  {
    iso: 'BL',
    dialCode: '+590',
  },
  {
    iso: 'SH',
    dialCode: '+290',
  },
  {
    iso: 'KN',
    dialCode: '+1869',
  },
  {
    iso: 'LC',
    dialCode: '+1758',
  },
  {
    iso: 'MF',
    dialCode: '+590',
  },
  {
    iso: 'PM',
    dialCode: '+508',
  },
  {
    iso: 'VC',
    dialCode: '+1784',
  },
  {
    iso: 'WS',
    dialCode: '+685',
  },
  {
    iso: 'SM',
    dialCode: '+378',
  },
  {
    iso: 'ST',
    dialCode: '+239',
  },
  {
    iso: 'SA',
    dialCode: '+966',
  },
  {
    iso: 'SN',
    dialCode: '+221',
  },
  {
    iso: 'RS',
    dialCode: '+381',
  },
  {
    iso: 'SC',
    dialCode: '+248',
  },
  {
    iso: 'SL',
    dialCode: '+232',
  },
  {
    iso: 'SG',
    dialCode: '+65',
  },
  {
    iso: 'SK',
    dialCode: '+421',
  },
  {
    iso: 'SI',
    dialCode: '+386',
  },
  {
    iso: 'SB',
    dialCode: '+677',
  },
  {
    iso: 'SO',
    dialCode: '+252',
  },
  {
    iso: 'ZA',
    dialCode: '+27',
  },
  {
    iso: 'SS',
    dialCode: '+211',
  },
  {
    iso: 'GS',
    dialCode: '+500',
  },
  {
    iso: 'ES',
    dialCode: '+34',
  },
  {
    iso: 'LK',
    dialCode: '+94',
  },
  {
    iso: 'SD',
    dialCode: '+249',
  },
  {
    iso: 'SR',
    dialCode: '+597',
  },
  {
    iso: 'SJ',
    dialCode: '+47',
  },
  {
    iso: 'SZ',
    dialCode: '+268',
  },
  {
    iso: 'SE',
    dialCode: '+46',
  },
  {
    iso: 'CH',
    dialCode: '+41',
  },
  {
    iso: 'SY',
    dialCode: '+963',
  },
  {
    iso: 'TW',
    dialCode: '+886',
  },
  {
    iso: 'TJ',
    dialCode: '+992',
  },
  {
    iso: 'TZ',
    dialCode: '+255',
  },
  {
    iso: 'TH',
    dialCode: '+66',
  },
  {
    iso: 'TL',
    dialCode: '+670',
  },
  {
    iso: 'TG',
    dialCode: '+228',
  },
  {
    iso: 'TK',
    dialCode: '+690',
  },
  {
    iso: 'TO',
    dialCode: '+676',
  },
  {
    iso: 'TT',
    dialCode: '+1868',
  },
  {
    iso: 'TN',
    dialCode: '+216',
  },
  {
    iso: 'TR',
    dialCode: '+90',
  },
  {
    iso: 'TM',
    dialCode: '+993',
  },
  {
    iso: 'TC',
    dialCode: '+1649',
  },
  {
    iso: 'TV',
    dialCode: '+688',
  },
  {
    iso: 'UG',
    dialCode: '+256',
  },
  {
    iso: 'UA',
    dialCode: '+380',
  },
  {
    iso: 'AE',
    dialCode: '+971',
  },
  {
    iso: 'GB',
    dialCode: '+44',
  },
  {
    iso: 'US',
    dialCode: '+1',
  },
  {
    iso: 'UY',
    dialCode: '+598',
  },
  {
    iso: 'UZ',
    dialCode: '+998',
  },
  {
    iso: 'VU',
    dialCode: '+678',
  },
  {
    iso: 'VE',
    dialCode: '+58',
  },
  {
    iso: 'VN',
    dialCode: '+84',
  },
  {
    iso: 'VG',
    dialCode: '+1284',
  },
  {
    iso: 'VI',
    dialCode: '+1340',
  },
  {
    iso: 'WF',
    dialCode: '+681',
  },
  {
    iso: 'YE',
    dialCode: '+967',
  },
  {
    iso: 'ZM',
    dialCode: '+260',
  },
  {
    iso: 'ZW',
    dialCode: '+263',
  },
];

/** Default dial code when value is empty or unknown */
export const DEFAULT_DIAL_CODE = '+1';

/**
 * Dial codes ordered by length descending for parsing (longest match first).
 * E.g. +358 before +35, +1 last among numeric prefixes.
 */
export const DIAL_CODES_SORTED_BY_LENGTH = [...PHONE_COUNTRY_CODES]
  .map(c => c.dialCode)
  .filter((v, i, a) => a.indexOf(v) === i)
  .sort((a, b) => b.length - a.length);

export type ParsedPhone = { dialCode: string; nationalNumber: string };

/**
 * Splits a full international phone string (e.g. "+15551234567") into dial code and national number.
 * Uses longest matching dial code. Returns DEFAULT_DIAL_CODE when value is empty or no match.
 */
export function parsePhoneValue(value: string | null | undefined): ParsedPhone {
  const raw = (value ?? '').trim();
  if (!raw) {
    return { dialCode: DEFAULT_DIAL_CODE, nationalNumber: '' };
  }
  const withPlus = raw.startsWith('+') ? raw : `+${raw.replace(/\D/g, '')}`;
  const digitsOnly = withPlus.replace(/\D/g, '');
  if (!digitsOnly) {
    return { dialCode: DEFAULT_DIAL_CODE, nationalNumber: '' };
  }
  for (const dial of DIAL_CODES_SORTED_BY_LENGTH) {
    if (withPlus === dial || withPlus.startsWith(dial)) {
      const national = withPlus.slice(dial.length).replace(/\D/g, '');
      return { dialCode: dial, nationalNumber: national };
    }
  }
  return { dialCode: DEFAULT_DIAL_CODE, nationalNumber: digitsOnly };
}

/** Strips non-digits from the national number part */
export function normalizeNationalNumber(input: string): string {
  return (input ?? '').replace(/\D/g, '');
}
